export default __webpack_public_path__ + "static/media/img_cancel.645aebfb.svg";